/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';
import { TipoPraticaStato } from './tipo-pratica-stato';
import { TipologiaPratica } from './tipologia-pratica';


export interface TipoPraticaEsercenteSummaryDTO { 
    id?: string;
    codice?: string;
    titolo?: string;
    descrizione?: string;
    tipologia?: TipologiaPratica;
    stato?: TipoPraticaStato;
    data_apertura?: string;
    data_chiusura?: string;
    url_documentazione?: string;
    puo_partecipare?: boolean;
    can_submit?: boolean;
    reason?: string;
    domanda_esistente_id?: string;
    domanda_esistente_stato?: RichiestaPraticaEsercenteStatus;
    adesioni_esercenti_fino?: string;
}



